import { z } from 'zod';
import { MessagingChannelKind } from './messaging-adapter';

export const CrmConversationsQuery = z.object({
  channel: MessagingChannelKind.optional(),
  cityId: z.uuid().optional(),
  assigneeUserId: z.uuid().optional(),
  /** Поиск по preview и displayName party. */
  q: z.string().trim().max(200).optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
  cursor: z.uuid().optional(),
});
export type CrmConversationsQuery = z.infer<typeof CrmConversationsQuery>;

export const CrmConversationListItemDto = z.object({
  id: z.uuid(),
  channel: MessagingChannelKind,
  channelAccountLabel: z.string().min(1).max(120),
  cityId: z.uuid().nullable(),
  crmPartyId: z.uuid().nullable(),
  contactLabel: z.string().min(1).max(200),
  previewText: z.string().nullable(),
  lastMessageAt: z.iso.datetime().nullable(),
  unreadForManager: z.number().int().nonnegative(),
  assignedManagerUserId: z.uuid().nullable(),
});
export type CrmConversationListItemDto = z.infer<typeof CrmConversationListItemDto>;

export const CrmConversationsListDto = z.object({
  items: z.array(CrmConversationListItemDto),
  nextCursor: z.uuid().nullable(),
});
export type CrmConversationsListDto = z.infer<typeof CrmConversationsListDto>;

export const CrmConversationMessagesQuery = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(50),
  beforeMessageId: z.uuid().optional(),
});
export type CrmConversationMessagesQuery = z.infer<typeof CrmConversationMessagesQuery>;

export const CrmConversationMessageDto = z.object({
  id: z.uuid(),
  direction: z.enum(['INBOUND', 'OUTBOUND', 'SYSTEM']),
  senderRole: z.enum(['CUSTOMER', 'MANAGER', 'SYSTEM']),
  body: z.string().nullable(),
  status: z.enum(['RECEIVED', 'QUEUED', 'SENT', 'DELIVERED', 'READ', 'FAILED']),
  occurredAt: z.iso.datetime(),
  /** Исходящие: сотрудник CRM, отправивший ответ (клиент видит корп. аккаунт). */
  sentByDisplayName: z.string().min(1).max(200).nullable(),
});
export type CrmConversationMessageDto = z.infer<typeof CrmConversationMessageDto>;

export const CrmConversationOutboundPolicyDto = z.object({
  allowed: z.boolean(),
  reason: z.string().max(500).optional(),
  attachmentsAllowed: z.boolean(),
});
export type CrmConversationOutboundPolicyDto = z.infer<typeof CrmConversationOutboundPolicyDto>;

export const CrmConversationMessagesDto = z.object({
  conversationId: z.uuid(),
  items: z.array(CrmConversationMessageDto),
  hasMore: z.boolean(),
  outbound: CrmConversationOutboundPolicyDto,
});
export type CrmConversationMessagesDto = z.infer<typeof CrmConversationMessagesDto>;

export const CrmMessagingChannelsDto = z.object({
  channels: z.array(
    z.object({
      kind: MessagingChannelKind,
      labelRu: z.string(),
      /** Адаптер и UI готовы (не «скоро»). */
      implemented: z.boolean(),
      /** Есть активный аккаунт/интеграция (для Telegram — ACTIVE в БД). */
      connected: z.boolean(),
    }),
  ),
});
export type CrmMessagingChannelsDto = z.infer<typeof CrmMessagingChannelsDto>;
